import React    from 'react'
import { Link } from 'react-router-dom'

import Zoom           from './zoom'
import { formatHTML } from './format'

import './css/preview.css'

import filePreview from './css/file-preview.png'

export default function Preview(props) {
  return !props.image ? '' : (
    <div className="preview">
      <div className="preview-display">
        <div className="preview-prev">
          {props.image.prev && (
            <Link to={props.image.prev.url} />
          )}
        </div>
        <div className="preview-preview">
          {props.zoom && props.image.large_url ? (
            <a target="_blank" href={props.image.large_url}>
              <Zoom
                title    = {props.image.title || props.image.caption} 
                caption  = {props.image.caption || props.image.title}
                smallURL = {props.image.small_url}
                largeURL = {props.image.large_url}
                lensSize = {250}
                hint     = {props.data.content.zoom_hint}
              />
            </a>
          ) : (props.image.youtube_id ? (
            <iframe
              src         = {props.image.youtube_url}
              title       = {props.image.title || props.image.caption}
              frameborder = "0"
              gesture     = "media"
              allow       = "encrypted-media"
              className   = "preview-video"
              allowFullScreen
            />
          ) : (props.image.large_url ? (
            <a target="_blank" href={props.image.large_url}>
              <img
                src       = {props.image.small_url || filePreview}
                alt       = {props.image.caption || props.image.title}
                className = "preview-image"
              />
            </a>
          ) : (
            <img
              src       = {props.image.small_url || filePreview}
              alt       = {props.image.caption || props.image.title}
              className = "preview-image"
            />
          )))}
        </div>
        <div className="preview-next">
          {props.image.next && (
            <Link to={props.image.next.url} />
          )}
        </div>
      </div>
      {props.zoom && (props.image.large_url ? (
        <div className="preview-hint">{props.data.content.zoom_hint}</div>
      ) : (
        <div className="preview-hint">{props.data.content.missing_hint}</div>
      ))}
      {props.image.caption && (
        <div className="preview-caption" dangerouslySetInnerHTML={{__html: formatHTML(props.image.caption)}} />
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/preview.js